/**
 * Component: ChatInput
 * Message input field with send button
 */

import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../context/TranslationContext';

export default function ChatInput({ onSendMessage, disabled, isLoading }) {
  const { t, loadPageTranslations } = useTranslation();
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    loadPageTranslations('CHATBOT');
  }, [loadPageTranslations]);

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = Math.min(
        textareaRef.current.scrollHeight,
        200
      ) + 'px';
    }
  }, [message]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled && !isLoading) {
      onSendMessage(message);
      setMessage('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white border-t border-gray-200 p-4 flex gap-2"
    >
      <textarea
        ref={textareaRef}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t('CHATBOT', 'MESSAGE_PLACEHOLDER', 'Type your message here... (Shift+Enter for new line)')}
        disabled={disabled}
        rows={1}
        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none disabled:bg-gray-100"
      />
      <button
        type="submit"
        disabled={disabled || !message.trim() || isLoading}
        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors"
      >
        {isLoading ? '...' : t('CHATBOT', 'SEND', 'Send')}
      </button>
    </form>
  );
}
